export default __webpack_public_path__ + "static/media/or-5.2c7f5f10.jpg";